import axios from '@/plugins/axios';
import qs from 'qs';
import utils from '@/stores/utils';
import catalogassignments from "./submodules/catalogassignments";
import catalogentries from './submodules/catalogentries';
import $utils from '@/utils';
import { CSV_EXPORT_LIMIT } from '@/constants/csv-export';

const { getStorageKey } = utils;

const state = {
    section: null,

    catalog: {},
    catalog_loading: false,
    catalog_loading_errors: null,
    catalog_cancel_source: null,
    catalog_saving: false,
    catalog_saving_errors: {},
    catalog_archiving: false,
    catalog_unarchiving: false,
    catalogentry: false,
    catalogentry_loading: false,
    catalogentry_loading_errors: null,
    catalogentry_saving: false,
    catalogentry_saving_errors: {},

};


const mutations = {
    updateSection(state, section) {
        state.section = section;
    },

    updateCatalog(state, catalog) {
        state.catalog = catalog;
        state.catalog_loading = false;
        state.catalog_loading_errors = null;

        if (catalog && state.catalog && state.catalog.id == catalog.id) {
            return;
        }
    },

    updateCatalogLoading(state) {
        state.catalog_loading = true;
        state.catalog_loading_errors = null;
    },
    updateCatalogLoadingErrors(state, errors) {
        state.catalog_loading = false;
        state.catalog_loading_errors = errors;
    },
    updateCatalogArchiving(state, archiving) {
        state.catalog_archiving = archiving;
    },
    updateCatalogUnarchiving(state, unarchiving) {
        state.catalog_unarchiving = unarchiving;
    },
    updateCatalogCancelSource(state, cancel_source) {
        state.catalog_cancel_source = cancel_source;
    },
};


const getters = {

};

const actions = {


    async patchCatalogEntry({ commit, dispatch, state }, params) {
        try {
            const response = await axios.put(`/api/catalogentries/${params.catalogentry.id}/`, {
                ...params.catalogentry,
                price: params.catalogentry.price,
                unit_agent_commission: params.catalogentry.unit_agent_commission,
                vat_rate: params.catalogentry.vat_rate,
            });
            await dispatch('entries/updateCatalogEntry', response.data);
            return response.data;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            throw error;
        }
    },

    exportToCSV({ commit, dispatch, state }, params) {
        let filters = {
            ...{
                format: 'csv',
                limit: CSV_EXPORT_LIMIT,
                catalog: state.catalog.id,
            }, ...(params || {})
        };
        
        const catalogName = state.catalog?.name || '';
        
        $utils.downloadFile({
            url: "/api/catalogentries/",
            params: filters,
        }, $utils.getFilename('catalogEntries', { catalog_name: catalogName }));
    },

    async archiveCatalog({ commit, dispatch, state }, params) {
        commit('updateCatalogArchiving', true);
        try {
            const response = await axios.post(`/api/catalogs/${state.catalog.id}/archive/`);
            dispatch('fetchCatalog');
            dispatch('session/fetchStats', null, { root: true });
            return response.data;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit('updateCatalogArchivingErrors', error.details);
            throw error;
        } finally {
            commit('updateCatalogArchiving', false);
        }
    },

    async unarchiveCatalog({ commit, dispatch, state }, params) {
        commit('updateCatalogUnarchiving', true);
        try {
            const response = await axios.post(`/api/catalogs/${state.catalog.id}/unarchive/`);
            dispatch('fetchCatalog');
            dispatch('session/fetchStats', null, { root: true });
            return response.data;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit('updateCatalogUnarchivingErrors', error.details);
            throw error;
        } finally {
            commit('updateCatalogUnarchiving', false);
        }
    },

    async fetchCatalog({ commit, dispatch, state }, params) {
        commit('updateCatalogLoading', true);

        if (state.catalog_cancel_source) {
            state.catalog_cancel_source.cancel("canceled");
        }

        const cancelSource = axios.CancelToken.source();
        commit('updateCatalogCancelSource', cancelSource);

        try {
            let url;
            if (params?.catalog_id) {
                url = `/api/catalogs/${params.catalog_id}/`;
            } else if (state?.catalog) {
                url = `/api/catalogs/${state.catalog.id}/`;
            } else {
                throw 'No catalog to fetch';
            }
            const response = await axios.get(url, {
                cancelToken: state.catalog_cancel_source?.token
            });
            commit('updateCatalogLoading', false);
            commit('updateCatalog', response.data);
            commit('updateCatalogCancelSource', null);
            return response.data;
        } catch (xhr_error) {
            if (axios.isCancel(xhr_error)) {
                return;
            }
            const error = utils.handleError(xhr_error);
            commit('updateCatalogLoadingErrors', error.details);
            throw error
        }
    },
    update({ commit, dispatch, state }, params) {
        dispatch('fetchCatalog');
        dispatch('entries/fetchCatalogEntries');
    },

    async init({ commit, dispatch, state }, params) {
        const entriesFilters = {
            catalog: params.catalog.id,
            ordering: 'product_name',
            include_archived: false,
        };
        if (
            params.productProviderId != null &&
            params.productProviderId !== ''
        ) {
            entriesFilters.provider = params.productProviderId;
        }
        await dispatch('entries/init', {
            url: `/api/productcatalogentries/`,
            catalog: params.catalog,
            fetch_stats: false,
            filters: entriesFilters,
            omitStoredFilterKeys: params.supplierSalesPricesContext
                ? ['provider']
                : undefined,
        });
        await dispatch("assignments/init", {
            catalog: params.catalog,
            filters: {
                catalog: params.catalog.id,
            },
        });
        await commit('updateCatalog', params.catalog);

        dispatch('entries/fetchCatalogEntries');
        dispatch("assignments/fetchCatalogAssignments");
    }

};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
    modules: {
        assignments: catalogassignments({
            storageKey: getStorageKey('assignedcatalog', 'assignments'),
            fieldsToSave: ['limit', 'ordering']
        }),
        entries: catalogentries({
            storageKey: getStorageKey('assignedcatalog', 'entries'),
            fieldsToSave: ['limit', 'ordering']
        }),
    }
};
